import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["organizationSelect", "propertySelect", "poiSelect"]

  connect() {
    this.updateLocations()
  }

  updateLocations(event) {
    const select = event ? event.target : this.element.querySelector('select[name="route_stop[stoppable_type]"]')
    const selectedType = select.value

    // Hide and disable all selects
    this.organizationSelectTarget.classList.add('hidden')
    this.organizationSelectTarget.querySelector('select').disabled = true

    this.propertySelectTarget.classList.add('hidden')
    this.propertySelectTarget.querySelector('select').disabled = true

    this.poiSelectTarget.classList.add('hidden')
    this.poiSelectTarget.querySelector('select').disabled = true

    // Show and enable the appropriate select
    switch(selectedType) {
      case 'Organization':
        this.organizationSelectTarget.classList.remove('hidden')
        this.organizationSelectTarget.querySelector('select').disabled = false
        break
      case 'MemberProperty':
        this.propertySelectTarget.classList.remove('hidden')
        this.propertySelectTarget.querySelector('select').disabled = false
        break
      case 'CustomPoi':
        this.poiSelectTarget.classList.remove('hidden')
        this.poiSelectTarget.querySelector('select').disabled = false
        break
    }
  }
}
